import _ from "lodash";

function getReferrerFullName() {
  return (ca, referrers) => {
    if (!_.isEmpty(_.get(ca, "referrer.firstName", ""))) {
      return `${ca.referrer.firstName} ${ca.referrer.lastName}`;
    }
    const referrerId = _.get(ca, "referrer.id", null);
    if (_.isEmpty(referrerId)) {
      return "";
    }
    const referrer = _.find(referrers, (referrer) => referrer.id === referrerId);
    if (_.isEmpty(referrer)) {
      return "";
    }
    return `${_.get(referrer, "firstName", "")} ${_.get(referrer, "lastName", "")}`;
  };
}

export default getReferrerFullName();
